module.exports = __webpack_public_path__ + "img/Home-incoming copy.238d91cf.png";